var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TitleOnboarding',{attrs:{"step":"return-policy","title":"Refund & Return Policy","page":true}}),_c('RefundPolicy',{attrs:{"page":true},on:{"save":_vm.onSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }